<div [formGroup]="form">
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <input type="text" autocompleteOff matInput formControlName="item" (keyup)="postalCodeChanged()" />
    <mat-hint *ngIf="maxLength" align="end">{{ itemControl.value?.length }} / {{ maxLength }}</mat-hint>
    <mat-error *ngIf="itemControl.hasError('pattern')">
      {{ 'Common.Invalid' | translate }} {{ 'Settings.Company.PostalCode' | translate }}
    </mat-error>
    <mat-error *ngIf="itemControl.hasError('blocked')">
      {{'Common.OnlySwissZipsAllowed' | translate}}
    </mat-error>
  </mat-form-field>
</div>